import React from 'react';
import { useState } from 'react';

export const StructureProduct = ({ imageUrl, label, showCheckbox }) => {

  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  }

  return (
    <div className="border product-card-2" onClick={handleClick}>
      <div className="p-3">
        <div className="image2">
          <img src={imageUrl} alt="" />
          <div className="etiquette container p-2 left-0 bottom-0">
            <span style={{ color: "white", fontWeight: "bold" }}>{label}</span>
          </div>
        </div>
        <div className="description mt-3">
          <div className="d-flex justify-content-between">
            <span />
            {showCheckbox && <div class="checkbox-container ">
              <input type="checkbox" className="custom-checkbox " checked={isChecked} />
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export const StructureInstallationProduct = ({image, name, checkbox}) => {

  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  }

  return (
    
    <div className="product-card product-card-2 border pt-3" onClick={handleClick} >
      <div className=" px-3 h-100 d-flex flex-column "  >
        <div className="image2    border" >
          <img src={image} alt=""  className=' mb-4 '/>
        </div>
        <div className="description pt-3">
          <p className="product-name ">{name}</p>
          <div className="py-3 d-flex justify-content-between">
            <span />
            <div class="checkbox-container ">
              <input type="checkbox" className="custom-checkbox " checked={isChecked} />
            </div>
                      </div>
        </div>
      </div>
    </div>
     
  )
}